export const environment = {
  production: true,
  api: 'https://agenda-api-oncoclinica.tecnoclinsaude.com.br',
  clinic: {
    id: '2327c090-ac34-44c6-b025-bf5733d5396b',
  },
  sso: 'https://sso.tecnoclinsaude.com.br/realms/agenda-mobile-dev/protocol/openid-connect',
  client_secret: '02C09klyirClffDZ5gh4UFcXYfGJAPRN',
  googleMapsApiKey: "AIzaSyBRhOQHnTq2zRKMkqWK3hLGSbw1_LafQ7Q",
};
